import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'

import { fetchPurchaseTemplates, selectPurchaseTemplate, resetCurrentPurchaseTemplate } from '../../actions/purchaseTemplates_actions';
import { resetCurrentPurchaseSchedule } from '../../actions/purchaseSchedules_actions';

import PurchaseScheduleModal from '../../components/Purchase/purchaseScheduleModal';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  if (values.IsEnabled === null ) {
      errors.IsEnabled = 'Required'
  } 
  return errors
}


let purchaseScheduleModal = reduxForm({
    form: 'purchaseScheduleModal',
})(PurchaseScheduleModal);

const selector = formValueSelector('purchaseScheduleModal')

function mapStateToProps(state) {
    const purchaseTemplateValue = selector(state, 'PurchaseTemplate_id');
    return {
        purchaseTemplateValue: purchaseTemplateValue,

        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
        purchaseTemplates: state.purchaseTemplates.all,
        isLoading: state.purchaseTemplates.isLoading,
        error: state.purchaseTemplates.error
    }
}

export default connect(mapStateToProps, { fetchPurchaseTemplates, selectPurchaseTemplate, resetCurrentPurchaseTemplate, resetCurrentPurchaseSchedule })(purchaseScheduleModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseScheduleModal.jsx